import { create } from 'zustand';

/** Whether the server can be reached, and how old the data on screen is when it cannot. */
interface ConnectivityState {
  online: boolean;
  /** When the copy last shown from this device was saved; null while data is live. */
  savedAt: string | null;
  /** A live answer arrived. */
  reached: () => void;
  /** No answer; `savedAt` is set when a saved copy was shown instead. */
  unreachable: (savedAt?: string | null) => void;
}

export const useConnectivity = create<ConnectivityState>()((set) => ({
  online: typeof navigator === 'undefined' ? true : navigator.onLine,
  savedAt: null,
  reached: () => set({ online: true, savedAt: null }),
  unreachable: (savedAt) => set((state) => ({ online: false, savedAt: savedAt ?? state.savedAt })),
}));

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => useConnectivity.getState().reached());
  window.addEventListener('offline', () => useConnectivity.getState().unreachable());
}
